// tslint:disable
/**
 * gbc API
 * gbc API swagger documentation
 *
 * OpenAPI spec version: 1.0.0
 * Contact: example@example.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export * from "./api";
export * from "./configuration";
